import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ShopWindowItem } from '../../model/shop-window-item';
import { MatSnackBar } from "@angular/material/snack-bar";
import { ProductService } from '../../services/product.service';

@Component({
    selector: 'pme-consulta-product-selector',
    templateUrl: './consulta-product-selector.component.html',
    styleUrls: ['./consulta-product-selector.component.scss'],
    standalone: false
})
export class ConsultaProductSelectorComponent {

  @Input()
  set packages(value: ShopWindowItem[]) {
    if (!value?.length) return;
    this.packagesFiltered = value;
    let profitable = value.find(pkg => pkg.profitable === true)

    if (!this.selectedOption) {
      this.selectedOption = profitable ? profitable : value[0];
    }

    const variablePkg = value.find(pkg => this.productService.isVariableProduct(pkg.product));

    if (variablePkg) {
      this.customValue = variablePkg.baseValue;
    }
  }

  @Input() isCampaign: boolean = false;

  @Output() buyClicked = new EventEmitter<any>();

  isOpen = false;
  selectedOption: ShopWindowItem | null = null;
  packagesFiltered: Array<ShopWindowItem> = [];
  customValue: number;
  showCustomValueError: boolean = false;

  constructor(private eRef: ElementRef, private _snackBar: MatSnackBar, public productService: ProductService) { }

  toggleSelect() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: any) {
    this.selectedOption = option;
    this.isOpen = false;


    if (this.productService.isVariableProduct(option.product)) {
      this.customValue = option.baseValue;
    }
  }

  checkCanPurchase(): boolean {

    return true;
  }

  getFormattedValue(value: number) {
    const valorParaFormatar = value || 0;
    const parts = valorParaFormatar.toFixed(2).split('.');

    return {
      integerPart: parts[0],
      decimalPart: parts[1]
    };
  }


  buy() {
    const index = this.packagesFiltered.findIndex(p =>
      p.product?._id === this.selectedOption?.product?._id
    );

    const valorFinal = this.productService.isVariableProduct(this.selectedOption.product)
      ? this.customValue
      : this.selectedOption.baseValue;

    this.buyClicked.emit({ i: index, customValue: valorFinal });
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    const clickedElement = event.target as HTMLElement;
    const isTriggerClick = clickedElement.closest('#select-consulta-product');

    if (!isTriggerClick) {
      this.isOpen = false;
    }
  }

  updateCustomValue(value: string) {
    this.customValue = Number(value);
  }

  checkCustomValue(event: any) {
    if (this.customValue < this.selectedOption.baseValue) {
      this.customValue = this.selectedOption.baseValue;
      this.customValue = this.selectedOption.baseValue;
      this.showCustomValueError = true;
    } else {
      this.showCustomValueError = false;

    }
    this.packagesFiltered.find(p => p.product.identifier.includes("variavel"))?.featureList.forEach(feature => {
      feature.requests = Math.floor(this.customValue / (Number(feature.toValue?.split("R$ ")[1].replace(",", ".")) || Number(feature.fromValue.split("R$ ")[1].replace(",", "."))));
    });
  }
}
